const initialState = {
  isLoading: false,
  policyLength: 0,
  typesLength: 0,
  error: null,
};

export const timeOffReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCHING_POLICY_LENGTH':
      return {
        ...state,
        isLoading: true,
      };
    case 'SET_POLICY_LENGTH':
      return {
        ...state,
        isLoading: false,
        policyLength: action.payload.policyLength,
      };
    case 'FETCH_POLICY_LENGTH_ERROR':
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    case 'FETCHING_TYPES_LENGTH':
      return {
        ...state,
        isLoading: true,
      };
    case 'SET_TYPES_LENGTH':
      return {
        ...state,
        isLoading: false,
        typesLength: action.payload.typesLength,
      };
    case 'FETCH_TYPES_LENGTH_ERROR':
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    default:
      return state;
  }
};
